import { Typography } from "@circleco/compass/components/Typography";
import type { Ref } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

import type { SuggestionItem } from "./types";

export interface SuggestionMenuRowProps {
  isActive: boolean;
  item: SuggestionItem;
  onHover: () => void;
  onSelect: () => void;
  rowRef?: Ref<HTMLButtonElement>;
}

export const SuggestionMenuRow = ({
  isActive,
  item,
  onHover,
  onSelect,
  rowRef,
}: SuggestionMenuRowProps) => (
  <button
    type="button"
    data-selected={isActive || undefined}
    ref={rowRef}
    className={classNames(
      "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left",
      isActive && "bg-secondary",
    )}
    onMouseDown={event => event.preventDefault()}
    onMouseMove={onHover}
    onClick={onSelect}
  >
    {item.visual && (
      <span className="flex shrink-0 items-center justify-center">
        {item.visual}
      </span>
    )}
    <span className="min-w-0 flex-1">
      <Typography variant="label-sm" className="block truncate">
        {item.label}
      </Typography>
      {item.description && (
        <Typography
          variant="body-sm"
          color="secondary"
          className="block truncate"
        >
          {item.description}
        </Typography>
      )}
    </span>
  </button>
);
